import { useMemo } from 'react'
import { jwtDecode } from 'jwt-decode'
import { useAuthStore } from '../../../store/authStore'

export interface AuthTokenPayload {
  first_name: string
  middle_name?: string | null
  last_name: string
  dob: string
  gender: string
  patient_id: string
  household_group_id: string
  state: string
  phone_number: string
  id: string
  token_type: string
  roles: string[]
  complete: null | boolean
  exp: number
}

export const useDecodedToken = () => {
  const token = useAuthStore((state) => state.token)

  if (!token) throw new Error('No token found')

  return useMemo(() => jwtDecode<AuthTokenPayload>(token), [token])
}
